import { module } from 'modujs'
import { lazyLoadImage } from '../utils/image'
import { $html } from '../utils/dom'
import { gsap } from '../lib/gsap'
import { clamp } from '../utils/maths'
import { Expo } from 'gsap'
import LocomotiveScroll from 'locomotive-scroll'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';

            window.scrollTo(0, 0);
        }

        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            initCustomTicker: render => gsap.ticker.add(render),
            destroyCustomTicker: render => gsap.ticker.remove(render),
        })

        // this.scroll.lenisInstance.on('scroll', ({ velocity }) => {
        //     const v = clamp(0, 1, Math.abs(velocity)/20)
        //     $html.style.setProperty('--scroll-velocity', v)
        // })

        // // Force scroll to top
        // if (history.scrollRestoration) {
        //     history.scrollRestoration = 'manual'
        //     window.scrollTo(0, 0)
        // }

        this.scroll.lenisInstance.options.content.addEventListener('wheel', (event) => {
            const targets = event.composedPath();

            const stopPropagation = targets.some(target => target.id === 'cc-main');
            if (stopPropagation) {
                event.stopPropagation();
            }
        });

    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * ```html
     * <div class="c-lazy o-ratio u-4:3">
     *     <img data-scroll data-scroll-call="lazyLoad, Scroll, main" data-src="http://picsum.photos/640/480?v=1" alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
     * </div>
     * ```
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    lazyLoad(args) {
        lazyLoadImage(args.target, null, () => {
            //callback
        })
    }

    scrollTo(params) {
        let { target, ...options } = params
        const $headerToolbar = document.getElementById('header-toolbar')

        options = Object.assign({
            // Defaults
            duration: 1,
            ease: Expo.easeInOut,
            offset: -1 * ($headerToolbar.offsetHeight + 2 * $headerToolbar.offsetTop)
        }, options)

        this.scroll?.scrollTo(target, options)
    }

    toggleVideo({ target, way }) {
        if (way === 'enter') {
            target?.play()
        } else {
            target?.pause()
        }
    }

    lock(stop=true) {
        if(stop) {
            this.scroll?.lenisInstance.stop()
        } else {
            this.scroll?.lenisInstance.start()
        }
    }

    removeScrollElements($oldContainer) {
        this.scroll?.removeScrollElements($oldContainer)
    }

    addScrollElements($newContainer) {
        this.scroll?.addScrollElements($newContainer)
    }

    destroy() {
        this.scroll?.destroy();
    }
}
